import React from 'react'
import { motion } from 'framer-motion/dist/framer-motion'

import './Section.scss'

const Section = ({ children, motionProps, name, className }) => {
    const { initial, animate, exit, transition } = motionProps
    return (
        <motion.section
            key={name}
            id={name}
            className={`mga-section ${className}`}
            initial={initial}
            animate={animate}
            exit={exit}
            transition={transition}
        >
            {children}
        </motion.section>
    )
}

Section.defaultProps = {
    motionProps: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.5 }
    }
}

export default React.memo(Section)